import { ApolloError } from "@apollo/client";
import { Box } from "@mui/material";

import WorkerReport, { WorkerReportFormValues } from "../WorkerReport";
import { ProjectReviewVisitV2TeamReportsRoute_TeamReportsFragment } from "./fragments.generated";

type Props = {
    data: ProjectReviewVisitV2TeamReportsRoute_TeamReportsFragment;
    error?: ApolloError;
    onUpdate: (reportId: string, values: WorkerReportFormValues) => void;
};

export default function TeamReportsList({ data, onUpdate, error }: Props) {
    return data.reportsV2.map(report => (
        <Box
            key={report.id}
            sx={theme => ({
                borderBottom: `1px solid ${theme.palette.divider}`,
                paddingBlock: 2,
                paddingInline: 2,
            })}
        >
            <WorkerReport
                report={report}
                form={data.protocol.researchType.submitForm}
                onSubmit={values => onUpdate(report.id, values)}
                error={error}
            />
        </Box>
    ));
}
